import {useTitle as vueUseUseTitle} from '@vueuse/core'
import {useStore} from 'shared/stores/store'

export const useTitle = (title, titleTemplate) => {
	const store = useStore()
	return vueUseUseTitle(title, {titleTemplate: titleTemplate || `%s - ${store.productName}`})
}
